import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class DataService {
  private dataSource = new BehaviorSubject<any>({ });
  data$ = this.dataSource.asObservable();

  constructor() { }

  changeData(data) {
    this.dataSource.next(data);
  }
}
